module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 11-08-21-679.fa6ab427.mp4";